import FileAttachment from "./FileAttachment";

import type { UploadedFile } from "../../../types";

interface FileAttachmentsListProps {
  uploadingFiles: File[];
  uploadedFiles: UploadedFile[];
  removeUploadingFileHandler: (file: File) => void;
  removeFile: (fileId: string) => void;
}

export default function FileAttachmentsList({
  uploadingFiles,
  uploadedFiles,
  removeUploadingFileHandler,
  removeFile,
}: FileAttachmentsListProps) {
  return (
    <div className="flex w-full flex-col gap-2 overflow-x-auto scrollbar-thin lg:flex-row lg:pb-2">
      {/* Uploading Files */}
      {uploadingFiles.map((file) => {
        const { name: fileName, size } = file;

        return (
          <FileAttachment
            key={file.name}
            file={{ name: fileName, size, url: file.name }}
            isUploading
            onRemove={() => removeUploadingFileHandler(file)}
          />
        );
      })}

      {/* Uploaded Files */}
      {uploadedFiles.map((file) => {
        const { id: fileId, file_url: fileUrl } = file;
        const { originalname: fileName, size } = file.file_input;

        return (
          <FileAttachment
            key={fileId}
            file={{ name: fileName, size, url: fileUrl }}
            onRemove={() => removeFile(fileId)}
          />
        );
      })}
    </div>
  );
}
